import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ConectionFailedComponent } from './pages/errors/conection-failed/conection-failed.component';
import { UnauthorizedComponent } from './pages/errors/unauthorized/unauthorized.component';
import { LoginComponent } from './pages/login/login.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.module').then((module) => module.PagesModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  { path: '401', component: UnauthorizedComponent },
  { path: '500', component: ConectionFailedComponent },
  {
    path: '**',
    redirectTo: 'unauthorized',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
